import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
import { TOAST_MESSAGES } from "../../RegularReservationActivity/RegularReservationView/utils/constants";
import { requestSaveReservationState } from "services/resources/universitySpaces/aboutUniversitySpaceResources";
import useMainContext from "utils/context/useMainContext";
import useResourcesUniversitySpacesContext from "views/Recursos/ResourcesUniversitySpaces/utils/context/useResourcesUniversitySpacesContext";
import { wait } from "utils/others";

const useSaveReservationInformation = ({
    updateActivityPopup,
	reservation, reservationState,
    reservationType
}) => {
    const mainContext = useMainContext();
    const { 
        loadingRequestOfReservationAction, 
        toastMessage, spaceList
    } = useResourcesUniversitySpacesContext();
    const dialogSaveInformationConfirmation = useShowDialogAlert();
    const dialogResponsibleNotAttended = useShowDialogAlert();
	async function saveReservationInformation() {
        dialogSaveInformationConfirmation.hide();
        loadingRequestOfReservationAction.show("Guardando información...");
        const finalized = reservationState.hasFinalized();
        const { success, newTimeEnd } = await requestSaveReservationState({
            reservationId: reservation.id,
            finalized, reservationType
        });
        loadingRequestOfReservationAction.hide();
        if (!success) {
            mainContext.setShowDialogUnexpectedError(true);
            return;
        }
        updateActivityPopup.popup.hide();
        await wait(220);
        toastMessage.show(TOAST_MESSAGES.SAVE_RESERVATION_STATE);
        const newReservation = {
            ...reservation, 
            finalized
        };
        if (newTimeEnd)
            newReservation.schedule = {
                ...newReservation.schedule,
                timeEnd: newTimeEnd
            };
        spaceList.reservations.update(newReservation, reservationType);
    }
	return {
		dialogSaveInformationConfirmation,
		dialogResponsibleNotAttended,
		saveReservationInformation
	};
}	
	
export default useSaveReservationInformation;